<script setup lang="ts">
import { Multiselect } from 'vue-multiselect';
import type { ListItemModel } from '../../_runtime/services/SubscriptionsCategoriesService';
import SubscriptionsCategoriesService from '../../_runtime/services/SubscriptionsCategoriesService';

const emit = defineEmits<{
    (e: 'update:modelValue', value: ListItemModel[]): void;
}>();

const props = defineProps<{
    modelValue: ListItemModel[];
}>();

const { $log } = useLogging();
const { $alert } = useAlerts();

const options = ref<Option[]>([]);

const categories = computed({
    get(): Option[]
    {
        return props.modelValue.map(p => ({
            text: p.name,
            value: p.id.toString()
        }));
    },
    set(value: Option[])
    {
        triggerModel(value);
    }
});

function triggerModel(value: Option[]): void
{
    emit('update:modelValue', value.map(p => ({
        name: p.text,
        id: parseInt(p.value),
        position: 0
    })));
}

const onSearchChanged = useDebounceFn(async (category: string): Promise<void> =>
{
    try
    {
        options.value = (await SubscriptionsCategoriesService.getAutocompleteList(category)).map(p => ({
            text: p.name,
            value: p.id.toString()
        }));
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });
    }
}, 500);
</script>

<template>
    <Multiselect
        v-model="categories"
        label="text"
        track-by="value"
        :options="options"
        :multiple="true"
        :taggable="true"
        :placeholder="$t('[[[Wyszukaj kategorię]]]')"
        :select-label="$t('[[[Naciśnij enter aby wybrać]]]')"
        :selected-label="$t('[[[Wybrano]]]')"
        :deselect-label="$t('[[[Naciśnij enter aby usunąć]]]')"
        :select-group-label="''"
        :deselect-group-label="''"
        :close-on-select="false"
        @search-change="onSearchChanged"
    >
        <template #noOptions>
            {{ $t('[[[Lista jest pusta]]]') }}
        </template>
        <template #noResult>
            {{ $t('[[[Nie znaleziono żadnych wyników.]]]') }}
        </template>
    </Multiselect>
</template>
